module.exports = __webpack_public_path__ + "8272cbb40a8cf521426ab0fd4bc38e7a.jpg";